import { useQuery } from "@tanstack/react-query";
import axios from "../../../services/axiosInstance";
import type { SitePerformanceData } from "../types/dashboard.types";

interface Params {
  accountId: string;
  subjectEmail: string;
  startDate: string;
  endDate: string;
  enabled: boolean;
}

export const useSitePerformance = ({
  accountId, subjectEmail, startDate, endDate, enabled,
}: Params) => {
  const accountName = accountId.startsWith("accounts/")
    ? accountId
    : `accounts/${accountId}`;

  const qs = new URLSearchParams({
    accountName, subjectEmail, startDate, endDate,
  }).toString();

  return useQuery<SitePerformanceData>({
    queryKey: ["gbp", "site-performance", accountId, subjectEmail, startDate, endDate],
    queryFn:  () => axios.get(`/api/gbp/performance/region-overview?${qs}`).then(r => r.data),
    enabled,
    staleTime: 1000 * 60 * 10,
  });
};